import { qltClient } from '../clients';
import { Repository } from '../core/repository';
import type { QueryParams } from '../core/params';
import type { QltViolation } from '../types';

export type ViolationCreatePayload = Omit<QltViolation, 'id' | '_id' | 'createdAt' | 'updatedAt'>;

// the conduct screen has no class note; subject may be null and grade is resolved server-side when missing
export interface ViolationBatchItem {
  grade?: string;
  class: string;
  student: string;
  subject: string | null;
  description: string;
  type: QltViolation['type'];
  date: string;
  semester: string;
}

const base = Repository<QltViolation>(qltClient, '/violations');

export const ViolationRepository = {
  ...base,
  list: (params: QueryParams) => base.fetch<QltViolation[]>(params),
  batchCreate: (items: Array<ViolationCreatePayload | ViolationBatchItem>) =>
    qltClient
      .post('/violations/batch', { items })
      .then((res) => res.data as QltViolation[]),
  // edit only touches type + content; everything else stays as recorded
  updateContent: (id: string, value: { type: QltViolation['type']; description: string }) =>
    base.update<QltViolation>(id, { type: value.type, description: value.description }),
};

export default ViolationRepository;
